"use strict";
function invariant(condition, message, context) {
    if (!condition) {
        var errorMessage = message;
        if (context) {
            errorMessage = (message.indexOf('%s') !== -1) ?
                message.replace('%s', context) :
                errorMessage = message + ": " + context;
        }
        throw new Error(errorMessage);
    }
}
exports.invariant = invariant;
//# sourceMappingURL=invariant.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-redux/lib/utils/invariant.js
 ** module id = 715
 ** module chunks = 0
 **/